import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FhMenuModel } from '../../../helpers/objects/fh-menu-model';
import { SharedFeaturesService } from '@fh-client-interaction-frontends/fh-providers';
import { FhMenuProviderService } from '../../../helpers/providers/fh-menu-provider.service';

@Component({
  selector: 'ui-fh-menu-dropdown',
  templateUrl: './fh-menu-dropdown.component.html',
  styleUrls: ['./fh-menu-dropdown.component.scss']
})
export class FhMenuDropdownComponent implements OnInit {
  @Input() parentItem: FhMenuModel = new FhMenuModel();
  @Input() items: FhMenuModel[] = new Array<FhMenuModel>();
  @Input() validateFeatures: boolean = true;
  @Output() itemClicked: EventEmitter<FhMenuModel> = new EventEmitter<FhMenuModel>();

  constructor(private sharedFeaturesService: SharedFeaturesService, private fhMenuProviderService: FhMenuProviderService) {}
  ngOnInit() {
    this.parentItem.expanded = this.fhMenuProviderService.isMenuExpanded;

    this.initData();
  }

  private async initData() {
    if (!this.validateFeatures) {
      return;
    }

    for (const item of this.items) {
      item.visible = await this.sharedFeaturesService.exists(item.tag, item.parentTag);
    }
    this.items = [...this.items];
  }

  onItemClicked(): void {
    if (!this.parentItem.expanded) {
      this.parentItem.dropdownOpen = false;
      if (this.parentItem.parentItem) {
        this.parentItem.parentItem.dropdownOpen = false;
      }
      this.itemClicked.emit(this.parentItem);
    }
  }
}
